<template>
  <multiselect v-model="selectedGroup"
               :options="groupsOptions"
               :multiple="false"
               :clear-on-select="false"
               :preserve-search="true"
               :show-labels="false"
               :show-no-results="false"
               :show-no-options="false"
               :allow-empty="false"
               :placeholder="$t('settings.generic.select-items')"
               label="name" track-by="id"
               class="tracking-multiselect fit-content groups-select">
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import {mapState} from "vuex";

export default {
  name: "GroupsSelect",
  components: {Multiselect},
  props: {
    modelValue: {
      type: [Object],
      default() { return null; }
    },
    addAllOption: {
      type: [Boolean],
      default: false
    },
    preselectAll: {
      type: [Boolean, null],
      default: true
    },
  },
  data() {
    return {
      selectedGroup: this.modelValue,
    };
  },
  mounted() {
    if (this.preselectAll && this.selectedGroup === null) {
      this.selectedGroup = this.allOption;
    }
  },
  watch: {
    selectedGroup(value) {
      this.onSelectGroup(value);
    },
    modelValue(value) {
      this.selectedGroup = value;
    }
  },
  computed: {
    allOption() {
      return {id: 0, name: this.$t('generic.all')};
    },
    isAllSelected() {
      return this.selectedGroup?.id === this.allOption.id;
    },
    ...mapState(['groups']),
    groupsOptions() {
      const groups = [...this.groups];
      groups.sort((a, b) => a.name.localeCompare(b.name));

      if (this.addAllOption) {
        groups.unshift(this.allOption);
      }

      return groups;
    },
  },
  methods: {
    onSelectGroup(data) {
      this.selectedGroup = data;
      this.$emit('update:modelValue', this.selectedGroup);
    },
  }
}
</script>

<style scoped lang="scss">
.groups-select {
  width: 200px;
  height: 37px;
}
</style>